// components/StepContainer.tsx
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface StepContainerProps {
  workflowStep: number;
  currentStep: number;
  isSubmitting: boolean;
  currentStepText: string;
  uploadProgress: number;
  completionComponent: React.ReactNode;
}

const StepContainer: React.FC<StepContainerProps> = ({
  workflowStep,
  currentStep,
  isSubmitting,
  currentStepText,
  uploadProgress,
  completionComponent,
}) => {

  if (workflowStep !== currentStep) return null;

  return (
    <div className="space-y-6">
      {isSubmitting ? (
        <Card className="bg-white border border-gray-200 shadow-sm">
          <CardContent className="p-6">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-gray-900">{currentStepText}</h3>
                <p className="text-sm text-gray-600">
                  Please wait while we process your request
                </p>
              </div>
            </div>
            <Progress value={uploadProgress} className="w-full" />
          </CardContent>
        </Card>
      ) : (
        completionComponent
      )}
    </div>
  );
};

export default StepContainer;